import { CLICKED, CMSPath, doNotDisturbCall, makeUpRoomCall } from '../../config/constant'
import { playDoorCameraStream } from '../../JS/playDoorCameraStream'
import {inAppBrowser} from './inAppBrowser';
import { DEMO } from '../../config/constant';
import { connect } from 'react-redux'
import { setOpenDemoCamera, setLoginRequired, setExternalSignIn } from '../action/homeAction'
import { getDefaultAnalyticsLabel } from './utility';
import { wipeGuestData } from '../../JS/wipeGuestData';
import { getRealtimeBookingUrl } from '../../action/homeAction';
import loader from '../UI/loader';
import { setShowCustomPopup } from '../../action/action';
import clientConfigApi from '../../config/config'

// import { connect } from 'react-redux'
let SessionToken = localStorage.getItem("GuestJourneySessionToken");

export const nonCompWidgetClick = async (widget, props) => {

    const { t } = props

    try {
        if (widget.compName === "App Launcher") {
            launcher(widget, props);
        }
        if (widget.compName === "Url Renderer") {
            console.log("url renderer---", widget.targetUrl);
 
            inAppBrowser(widget.targetUrl,props,false, widget);
        }
        if (widget.compName === "The Know(Already Joined)") {
            console.log("The Know(Already Joined)---", widget.targetUrl);
 
            inAppBrowser(widget.targetUrl,props,false, widget);
        }
        if (widget.compName === "Gallery App") {
            console.log("Gallery App", widget.targetUrl);
            inAppBrowser(widget.targetUrl,props,false, widget);
        }
        if (widget.compName === "URL Renderer – Logged in") {
            console.log("url renderer – Logged in", widget.targetUrl);
            let room = localStorage.getItem("room");
    
            if (!room || room === "null") {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    props.setLoginRequired(true)
                } else {
                    props.setRegPage(true);
                }
              console.log("room", room);
              return;
            }
            //window.open(widget.targetUrl);
    
            if (widget.targetUrl) {
              inAppBrowser(widget.targetUrl,props,false, widget)
            }
          }
        if (widget.compName === "RealTime Booking"){
            console.log("Url renderer -- Realtime booking");
            let room = localStorage.getItem("room");

            if (!room || room === "null") {
                inAppBrowser(widget.targetUrl,props,false,widget)        
                return;
            }

            props.setLoader(true, t('loader.loading') , false)
            getRealtimeBookingUrl((callback , msg ) => {
                if(callback){
                    props.setLoader(false)
                    inAppBrowser(msg,props,false,widget)
                }else{
                    props.setLoader(false)
                    // props.popupOpenClose(true, msg || "Something went wrong. Please try again later.");
                    inAppBrowser(widget.targetUrl,props,false,widget)
                    console.log("Error callback from realtime res api : " + msg);
                }
            })
        }
        if(widget.widgetType == "SMS Message"){
            await props.currentWidget(widget)
            console.log("in SMS Message widget");
            props.openSMSWidget(true);
        }
        if(widget.widgetType == "Guest Details"){
            let room = localStorage.getItem('room');
            if(room && room != "null"){
                props.setOpenProfileImage(true);
            }else{
                props.setRegPage(true);
            }
        }
        if (widget.compName === "Hotel Guide") {
            console.log("Hotel Guide", `${CMSPath}${widget.targetUrl}`);
            if (widget.targetUrl) {
                inAppBrowser(widget.targetUrl,props,true, widget)
            }
        }
        if (widget.compName === "Privacy Policy") {
            console.log("Privacy Policy", `${CMSPath}${widget.targetUrl}`);
            if (widget.targetUrl) {
                inAppBrowser(widget.targetUrl,props,false, widget)
            }
        }
        if (widget.compName === "Terms and Condition") {
            console.log("Terms and Condition", `${CMSPath}${widget.targetUrl}`);
            if (widget.targetUrl) {
                inAppBrowser(widget.targetUrl,props,false, widget)
            }
        }
        if (widget.compName === "FAQ") {
            console.log("FAQ", `${CMSPath}${widget.targetUrl}`);
            if (widget.targetUrl) {
                inAppBrowser(widget.targetUrl,props,false, widget)
            }
        }
        if (widget.compName === "Door Camera") {
            let room = localStorage.getItem("room");
            if (!room || room === "null") {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    props.setLoginRequired(true)
                } else {
                    props.setRegPage(true);
                }
                return;
            }
            // props.closeOrderPopUp( true, "Opening Door Camera", null, null)
            if(DEMO){
                props.setOpenDemoCamera(true)
                return;
            }
            console.log("called the door camera");
            if (props.streamingUrlFromConfig) {
                playDoorCameraStream(props.streamingUrlFromConfig, props);
            } else {
                console.log("URL is not there in client config.");
                props.popupOpenClose(true, "This functionality temporarily not available.");
            }
        }
        if (widget.compName === "MUR") {
            let room = localStorage.getItem("room");
            await props.guestDetails(SessionToken, wipeGuestData, props.guestDetail.guestToken)
            if (!room || room === "null") {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    props.setLoginRequired(true)
                } else {
                    props.setRegPage(true);
                }
                return;
            }
            // if(DEMO){
            //     return;
            // }
            props.setLoader(true, t('loader.sending_request'), false)
            if ((localStorage.getItem("roomControlInterface") || process.env.REACT_APP_ROOMCONTROLTYPE ) == 'VDA') {
                props.VDAsendCommand(
                    "makeUpRoomCall", "", "", props.zoneId, props.guestDetail, (status) => {
                        props.setLoader(false);
                        if (status) {
                            props.setMURon(true);
                            props.closeOrderPopUp(true, `Request sent for ${widget.displayName}`, "", false);
                        } else {
                            props.setMURon(false);
                            props.closeOrderPopUp(true, `Something went wrong while sending request for ${widget.displayName}`, "", true)
                        }
                    }, props.zoneId);
            }
            else {
                props.sendAcCommand(
                    "murToggleCommand", null, null, null, props.guestDetail,
                    null,  (section, status) => {
                        props.setLoader(false);
                        if (status) {
                          props.setMURon(true);
                          props.closeOrderPopUp(true, `Request sent for ${widget.displayName}`, "", false);
                        } else {
                          props.setMURon(false);
                          props.closeOrderPopUp(true,`Something went wrong while sending request for ${widget.displayName}`, "", true)
                        }
                      }, props.roomControlSpecificVersion
                );
            }

            // Send Analytics
            let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
                props.sendAnalytics(
                props.guestDetail, 
                props.currentWidgets.displayName, 
                CLICKED, 
                {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget"}, 
                0, 
                props.guestIsLoggedIn
            );
            // 

            ///below code is reqiured to show the status bubble on the DND and MUR

            // if(!props.MUR){
            //     } else {
            //     props.sendAcCommand(
            //         "murToggleCommand", null, null, null, props.guestDetail,
            //         null, (status) => status ? props.setMURon(false) : props.setMURon(true)
            //     );
            // }
            console.log('props.MUR',props.MUR)

            // props.closeOrderPopUp( true, "Make-up my room request sent", null, null)
            // if (props.VDAZoneList.length > 0) {
            //     props.sendCommand(
            //         makeUpRoomCall, props.guestDetail,
            //         "MakeUpRoom", DNDandMakeUpcallBack, null,
            //         props.VDAZoneList[0].zoneId
            //     );
            // }
        }
        if (widget.compName === "DND") {
            let room = localStorage.getItem("room");
            await props.guestDetails(SessionToken, wipeGuestData, props.guestDetail.guestToken)
            if (!room || room === "null") {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    props.setLoginRequired(true)
                } else {
                    props.setRegPage(true);
                }
                return;
            }
            // if(DEMO){
            //     return;
            // }
            props.setLoader(true, t('loader.sending_request'), false)
            if ((localStorage.getItem("roomControlInterface") || process.env.REACT_APP_ROOMCONTROLTYPE) == 'VDA') {
                props.VDAsendCommand(
                    "doNotDisturbCall", "", "", props.zoneId, props.guestDetail, (status) => {
                        props.setLoader(false);
                        if (status) {
                            props.setDNDon(true);
                            props.closeOrderPopUp(true, `Request sent for ${widget.displayName}`, "", false);
                        } else {
                            props.setDNDon(false);
                            props.closeOrderPopUp(true, `Something went wrong while sending request for ${widget.displayName}`, "", true)
                        }
                    }, props.zoneId);
            }
            else {
                props.sendAcCommand(
                    "dndToggleCommand", null, null, null, props.guestDetail,
                    null, (section, status) => {
                        props.setLoader(false);
                        if (status) {
                            props.setDNDon(true);
                            props.closeOrderPopUp(true, `Request sent for ${widget.displayName}`, "", false);
                        } else {
                            props.setDNDon(false);
                            props.closeOrderPopUp(true, `Something went wrong while sending request for ${widget.displayName}`, "", true)
                        }
                    }, props.roomControlSpecificVersion
                );
            }

            // Send Analytics
            let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
                props.sendAnalytics(
                props.guestDetail, 
                props.currentWidgets.displayName, 
                CLICKED, 
                {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget"}, 
                0, 
                props.guestIsLoggedIn
            );
            // 
            
            // if(!props.DND){
            //     } else {
            //     props.sendAcCommand(
            //         "murToggleCommand", null, null, null, props.guestDetail,
            //         null, (status) => status ? props.setMURon(false) : props.setMURon(true)
            //     );
            // }
            console.log('props.DND',props.DND)
            // props.closeOrderPopUp( true, "Turning on Do-Not-Disturb", null, null)
            // if (props.VDAZoneList.length > 0) {
            //     props.sendCommand(
            //         doNotDisturbCall, props.guestDetail,
            //         "DND", DNDandMakeUpcallBack, null, props.VDAZoneList[0].zoneId
                // );
            // }
        }

        if(widget.compName == "Door Unlock"){

            let room = localStorage.getItem("room");
            if (!room || room === "null") {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    props.setLoginRequired(true)
                } else {
                    props.setRegPage(true);
                }
                return;
            }

            props.setLoader(true, t('loader.sending_request') , false)
            props.sendAcCommand(
                "unlockDoor", "DOOR", "", "DOOR", props.guestDetail,
                null, (section, status) => {
                    props.setLoader(false);
                    
                    if(status){
                        props.closeOrderPopUp(true,`Request sent for ${widget.displayName}`, "", false)
                    } else {
                        props.closeOrderPopUp(true,`Something went wrong while sending request for ${widget.displayName}`, "", true)
                    }
                }, props.roomControlSpecificVersion
            );

            // Send Analytics
            let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
                props.sendAnalytics(
                props.guestDetail, 
                props.currentWidgets.displayName, 
                CLICKED, 
                {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget"}, 
                0, 
                props.guestIsLoggedIn
            );
        }

        if(widget.widgetType == "Widget Not Supported"){
            const message = t('widgetTypeNotSupported.message')
            .replace("#widgetName", widget.widgetTitle)
            .replace("#widgetDesc",widget.widgetDesc)

           props.popupOpenClose(true, message)
          
        }

        if(widget.widgetType == "E-tip"){
                try {
                    let room = localStorage.getItem("room");
                    if (!room || room === "null") {
                        if(process.env.REACT_APP_INROOMTAB == "true") {
                            props.setLoginRequired(true)
                        } else {
                            props.setRegPage(true);
                        }
                      console.log("room", room);
                      return;
                    }
                    props.setLoader(true);
                    clientConfigApi.post("eTip/tipjarUrl", 
                        {
                            header: {},
                            payload: {
                                roomNumber: room,
                                sessionToken: SessionToken
                            }
                        }
                    )
                        .then((response) => {
                            console.log("API call successful:", response,response.data);
                            props.setLoader(false);
                            if(response.data && response.data.payload && response.data.payload.data)
                            inAppBrowser(response.data.payload.data.tipjar.url,props,false, widget);
                        })
                        .catch((error) => {
                            console.error("Error occurred during api call:", error);
                            props.setLoader(false);
                            props.popupOpenClose(true, "Something went wrong");
                        });
                    
                } catch (error) {
                    console.error("Error in E-tip:", error);
                    props.setLoader(false); 
                }    
        }

        if(widget.widgetType == "eTip"){
                try {
                    let room = localStorage.getItem("room");
                    if (!room || room === "null") {
                        if(process.env.REACT_APP_INROOMTAB == "true") {
                            props.setLoginRequired(true)
                        } else {
                            props.setRegPage(true);
                        }
                      console.log("room", room);
                      return;
                    }
                    props.setLoader(true);
                    clientConfigApi.post("eTip/tipjarUrl", 
                        {
                            header: {
                                sessionToken: SessionToken
                            },
                            payload: {
                                roomNumber: room
                            }
                        }
                    )
                        .then((response) => {
                            console.log("API call successful:", response,response.data);
                            props.setLoader(false);
                            if(response.data && response.data.payload && response.data.payload.data) {
                                inAppBrowser(response.data.payload.data.tipjar.url,props,false, widget);
                            } else {
                                props.closeOrderPopUp(true, "Something went wrong", "", true);
                            }
                        })
                        .catch((error) => {
                            console.error("Error occurred during api call:", error);
                            props.setLoader(false);
                            props.closeOrderPopUp(true, "Something went wrong", "", true);
                        });
                    
                } catch (error) {
                    console.error("Error in E-tip:", error);
                    props.setLoader(false); 
                }    
        }

    } catch (errorMsg) {
        console.log("error in on click", errorMsg);
    }

}

const DNDandMakeUpcallBack = () => {

}
const launcher = (widget, props) => {
    let launchInfo;
    props.appLauncherWidget.map(
        (iterator) => {
            if (widget.widgetTypeId === iterator.id) {
                launchInfo = iterator;
            }
        }
    )
    if (launchInfo.onClickTargetPackageId || launchInfo.onClickTargetIosUri) {
        if (window.device && window.device.platform === "Android") {
            window.plugins.launcher.launch(
                { packageName: launchInfo.onClickTargetPackageId, },
                //{ packageName: props.packageName, },
                () => { console.log("launched a link") },
                () => {
                    console.log("error while launching link");
                    props.popupOpenClose(true, "Unable to open this App.");
                }
            );
        } else if (window.device && window.device.platform === "iOS") {


            // window.location.assign(launchInfo.onClickTargetIosUri)
            const ref = window.cordova.InAppBrowser.open(launchInfo.onClickTargetIosUri, '_system',`location=no`);

            setTimeout(() => {
                
                if(!ref){
                    props.closeOrderPopUp(true,"Unable to open this App", "", true)
                }
            }, 800);

            // window.plugins.launcher.launch(
            //     { uri: launchInfo.onClickTargetIosUri, },
            //     // { uri: props.urlScheme, },
            //     () => { console.log("launched a link") },
            //     () => {
            //         console.log("error while launching link");
            //         props.popupOpenClose(true, "Unable to open this App.");
            //     }
            // );
        } else {
            //console.log("it is not for desktop.");
            window.location.assign(launchInfo.onClickTargetIosUri)

            setTimeout(() => {
                props.closeOrderPopUp(true,"Unable to open this App", "", true)
            }, 1500);
        }
    } else {
        alert("both pakage name and URI scheme are not available.");
    }
}

const mapStateToProps = state => {
    return {
        externalSignIn: state.store2.externalSignIn,
    }
}
export default connect(
    mapStateToProps,
    {
        setLoginRequired,
        setShowCustomPopup,
        setExternalSignIn
    }
)(nonCompWidgetClick);